"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EtudeError_1 = require("../error/EtudeError");
class Direction {
    constructor() {
        ++Direction.size;
        Direction._values.push(this);
    }
    static values() {
        return Direction._values.slice();
    }
    ordinal() {
        return Direction._values.indexOf(this);
    }
    static valueOf(directionString) {
        const direction = Direction[directionString];
        if (direction instanceof Direction) {
            return direction;
        }
        throw EtudeError_1.default.forInvalid(Direction, directionString);
    }
    toString() {
        return Object.keys(Direction).find(d => Direction[d] === this);
    }
}
Direction.size = 0;
Direction._values = [];
Direction.ASCENDING = new Direction();
Direction.DESCENDING = new Direction();
Direction.DEFAULT = Direction.ASCENDING;
exports.default = Direction;
